import { graphql } from "relay-runtime"
import { chPatientByIdQuery$data } from "@/modules/patients/services/ch/__generated__/chPatientByIdQuery.graphql"

const chPatientByIdQuery = graphql`
  query chPatientByIdQuery($patientId: ID!, $appointmentId: ID, $language: String!) {
    patientById: ch_patientById(id: $patientId) {
      __typename
      ...PatientFragment
      ...PatientFragmentInline

      ...submitBtnAgendaTeleconsultationPatientFragment

      id
      patientId
      medgateServiceInfo {
        externalAssistanceServiceInfo {
          name
        }
        genericsObligation
        betterDoc
        hasBetterDocConditionPackage
        isMedgateTeleGeneralPractitioner
        isMedicalChatEnabled
        referralToGeneralPractitioner
        referralToSpecialist
        hasInsuranceListReferralToGeneralPractitioner
        hasInsuranceListReferralToSpecialist
        isEligibleToPartnerPortal
      }
      emailAddress
      phoneNumber
      callerPhoneNumbers
      contactChannel
      contactChannelUpdatedAt
      createdAt
      emailVerification {
        ...chEmailVerificationFragment @relay(mask: false)
      }
      preventionPrograms(first: null) @connection(key: "PatientPreventionProgramsConnection_preventionPrograms") {
        edges {
          cursor
          node {
            ...PatientPreventionProgramOutputFragment @relay(mask: false)
          }
        }
      }
      address {
        ...PatientHomeAddressFragment @relay(mask: false)
      }
      contextAppointment: appointment(id: $appointmentId) {
        ...PatientContextAppointmentFragment
      }
      healthInformationVerifications(appointmentId: $appointmentId) {
        appointmentId
        healthInformationType
        id
        patientId
        verifiedAt
        verifiedBy
      }
      healthInformationLastVerification {
        healthInformationType
        id
        patientId
        verifiedAt
        verifiedBy
      }
      caveEntry {
        message
        updatedAt
        updatedBy
      }
      doctorNetworks {
        id
        role
        careProvider {
          id
          businessName
          title
          firstName
          lastName
          groupName(language: $language)
          careProviderSpecialtyTranslations(language: $language) {
            name
          }
          officialLanguageLookupTranslations(language: $language) {
            isoLanguageName
          }
          officialLanguages {
            isoLanguageCode
          }
          careProviderGroup {
            groupType
          }
          country {
            countryName(language: $language)
          }
          creditorCodeRegister
          isMedgatePartnerNetworkMember
          isTakesNewPatients
          phoneNumber
          email
          website
          globalLocationNumber
          countryCode
          city
          postalCode
          streetAddress
          additionalAddress
          relationType
          relationBusinessName
          relationFirstName
          relationLastName
          relationTitle
          billsVia {
            businessName
            firstName
            lastName
            title
          }
          network {
            name
          }
          detailedSchedule {
            day
            workingType
            periods {
              start
              end
            }
          }
        }
      }
      insurees {
        ...chPatientInsureesFragment @relay(mask: false)
      }
      conditionInformation {
        ...PatientConditionInformationOutputFragment
      }
      gynaecology {
        ...GynaecologyFragment
      }
      allergiesInformation {
        ...PatientAllergiesOutputFragment
      }
      familyHistory {
        ...FamilyHistoryFragment
      }
      socialHistory {
        ...SocialHistoryFragment
      }
      bodyMeasurements(first: null) @connection(key: "PatientByIdConnection_bodyMeasurements") {
        edges {
          ...PatientBodyMeasurementsOutputFragment
          ...PatientBodyMeasurementsOutputFragmentInline
        }
      }
      medications: ch_medications(first: null) @connection(key: "PatientByIdConnection_ch_medications") {
        edges {
          node {
            id
            startDate
            endDate
            ...chMedicationFragment
            ...chMedicationFragmentInline
          }
        }
      }
      account {
        ...chAccountFragment @relay(mask: false)
      }
      duplicateOfPatient {
        id
      }
      hasUpcomingPlannedAppointment
      teleGpOnboardingPerformed
      socialSecurityNumber
      ch_hasNonMedgateInDoctorNetwork
    }
  }
`

type ChInsurees = NonNullable<chPatientByIdQuery$data["patientById"]>["insurees"]

type ChInsuree = NonNullable<chPatientByIdQuery$data["patientById"]>["insurees"][number]

type ChMedgateServiceInfo = NonNullable<chPatientByIdQuery$data["patientById"]>["medgateServiceInfo"]

export { chPatientByIdQuery as ch_PatientByIdQuery, type ChInsuree, type ChInsurees, type ChMedgateServiceInfo }
